import React from 'react';
import MobileTabBar from './MobileTabBar';

/**
 * Wrapper de pantalla mobile: header opcional, contenido scrollable y la
 * tab bar inferior. El padding-bottom deja lugar a la tab bar (56px) más el
 * safe-area-inset.
 */
export default function MobileShell({ title, leading, trailing, children, hideTabBar = false }) {
  return (
    <div className="mobile-shell min-h-[100dvh] flex flex-col bg-surface text-on-surface">
      {(title || leading || trailing) && (
        <header
          className="sticky top-0 z-40 bg-surface/95 backdrop-blur border-b border-outline-variant flex items-center gap-2 px-4 h-14"
          style={{ paddingTop: 'env(safe-area-inset-top, 0)' }}
        >
          {leading}
          <h1 className="flex-1 text-base font-bold truncate">{title}</h1>
          {trailing}
        </header>
      )}
      <main
        className="flex-1 overflow-y-auto"
        style={{ paddingBottom: hideTabBar ? 0 : 'calc(56px + env(safe-area-inset-bottom, 0))' }}
      >
        {children}
      </main>
      {!hideTabBar && <MobileTabBar />}
    </div>
  );
}
